import { ErrorMessage, Field, Form, Formik } from 'formik';
import moment from 'moment/moment';
import React, { memo } from 'react';
import DatePicker from 'react-datepicker';
import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';

import style from '../../styles/layout.module.css';

const WarrantyDateSettingModal = ({
  toggleModal,
  handleSubmit,
  getValidationSchema,
  modal,
  info,
  otherReason,
  setOtherReason,
  addLoading,
  submitLoading,
}) => {
  const newOptions = [
    '發票、購買明細缺少購買日期，須補件',
    '發票、購買明細品項名稱有誤或不明，須補件',
    '請補上傳保卡內頁蓋章或發票、購買明細，以利查證',
    '請補上傳發票、訂單頁面截圖或保卡封面日期及內頁蓋章',
    '若商品為刷卡禮贈送，請上傳含日期註記之銀行兌換頁面截圖',
    '若商品為公司贈禮，請上傳贈禮圖示或相關證明截圖',
  ];
  const oldOptions = [
    '發票與保卡未正確拍攝上傳',
    '發票與保卡之有效資訊不全',
    '產品序號有誤',
    '請補上傳保卡正本背面(亂碼序號)，以利查證',
    '請補上傳保卡正本正面(日期、蓋章)或購買明細/發票，以利查證',
  ];

  // Determine the initial reason: prefer explicit info.reason; otherwise pick the most recent remark.reason (by date if available, fallback to id)
  const getLatestRemarkWithReason = remarks => {
    if (!remarks || !remarks.length) return null;
    return remarks.reduce((best, r) => {
      if (!r || !r.reason || !r.reason.toString().trim()) return best;
      if (!best) return r;
      // compare by remark.date (format 'YYYY/MM/DD HH:mm') if present
      const bestDate = best.date ? moment(best.date, 'YYYY/MM/DD HH:mm') : best.creatTime ? moment(best.creatTime) : null;
      const rDate = r.date ? moment(r.date, 'YYYY/MM/DD HH:mm') : r.creatTime ? moment(r.creatTime) : null;
      if (bestDate && rDate) {
        return rDate.isAfter(bestDate) ? r : best;
      }
      // fallback to id comparison
      if (r.id && best.id) return r.id > best.id ? r : best;
      return best;
    }, null);
  };
  const latestRemark = info && info.remarks ? getLatestRemarkWithReason(info.remarks) : null;
  const infoReason = (info && info.reason) || (latestRemark && latestRemark.reason) || '';
  const initialReason = infoReason || '';
  const initialReasonOption = initialReason
    ? newOptions.includes(initialReason)
      ? initialReason
      : oldOptions.includes(initialReason)
      ? initialReason
      : 'OTHER'
    : 'OTHER';
  const initialOtherText = initialReason && !newOptions.includes(initialReason) && !oldOptions.includes(initialReason) ? initialReason : '';
  return (
    <Modal
      zIndex={2000}
      centered
      size="lg"
      isOpen={modal}
      toggle={toggleModal}
      backdrop="static"
    >
      <ModalHeader className={style.modal_head} toggle={toggleModal}>
        保固日期設定
      </ModalHeader>
      <Formik
        enableReinitialize
        initialValues={{
            purchaseDate:
              info && info.purchaseDate_admin
                ? new Date(info.purchaseDate_admin)
                : '',
            reason: initialReason,
            reasonOption: initialReasonOption,
            otherText: initialOtherText,
            repairRegisterNum:
              info && info.repairRegisterNum ? info.repairRegisterNum : '',
            shippingDate:
              info && info.productDate_admin
                ? new Date(info.productDate_admin)
                : '',
            startDateType_admin:
              info && info.startDateType_admin
                ? info.startDateType_admin.toString()
                : '',
            status: info && info.status ? info.status : '',
            warrantyEndDate:
              info && info.warrantyEndDate ? new Date(info.warrantyEndDate) : '',
          }}
        onSubmit={handleSubmit}
        validationSchema={getValidationSchema}
      >
        {props => {
          const normalize = s => (s || '').toString().replace(/\s+/g, ' ').trim();
          const currentReason = props.values.reason || infoReason || '';
          const matchedOldOption = infoReason
            ? oldOptions.find(o => {
                const no = normalize(o);
                const nr = normalize(infoReason);
                return no === nr || nr.includes(no) || no.includes(nr);
              })
            : null;
          const isOldReason = !!matchedOldOption;
          const isMatch = (opt) => {
            const sel = normalize(props.values.reasonOption && props.values.reasonOption !== 'OTHER' ? props.values.reasonOption : props.values.reason || '');
            const o = normalize(opt);
            if (!sel) return false;
            return sel === o || sel.includes(o) || o.includes(sel);
          };
          const anyMatch = () => {
            return newOptions.concat(oldOptions).some(o => isMatch(o));
          };
          return (
          <Form className="form-list form-label-140">
            <ModalBody className={style.modal_body}>
              <div className={style.formGroup}>
                <label style={{ minWidth: '130px' }}>維修單號</label>
                <Input
                  name="repairRegisterNum"
                  onChange={event => {
                    props.setFieldValue(
                      'repairRegisterNum',
                      event.target.value,
                    );
                  }}
                  value={props.values.repairRegisterNum}
                />
              </div>

              {info?.warrantyDays ? (
                <div className={style.formGroup}>
                  <label style={{ width: '130px' }}>
                    保固起始日{' '}
                    <ErrorMessage
                      name="startDateType_admin"
                      component="span"
                      className="form-error"
                    />
                    <ErrorMessage
                      name="purchaseDate"
                      component="h6"
                      className="form-error"
                    />
                    <ErrorMessage
                      name="shippingDate"
                      component="h6"
                      className="form-error"
                    />
                  </label>
                  <div>
                    <div className="d-flex mb-3">
                      <Field
                        name="startDateType_admin"
                        type="radio"
                        id="purchase"
                        value="1"
                      >
                        {({ form, field }) => {
                          const { setFieldValue, values } = form;
                          const { value } = field;
                          return (
                            <input
                              className="me-2"
                              type="radio"
                              style={{ lineHeight: '38px' }}
                              checked={values.startDateType_admin == 1}
                              onChange={() => {
                                setFieldValue('startDateType_admin', value);
                                setFieldValue(
                                  'warrantyEndDate',
                                  values.purchaseDate
                                    ? moment(values.purchaseDate)
                                        .add(
                                          info?.isInExtendDays
                                            ? info?.warrantyDays +
                                                info?.extendDays
                                            : info?.warrantyDays,
                                          'day',
                                        )
                                        .toDate()
                                    : '',
                                );
                              }}
                            />
                          );
                        }}
                      </Field>
                      <label
                        className="w100"
                        htmlFor="purchase"
                        style={{ lineHeight: '38px' }}
                      >
                        購買日期
                      </label>
                      <Field name="purchaseDate">
                        {({ field, form }) => {
                          const { setFieldValue, values } = form;
                          const { value } = field;
                          return (
                            <DatePicker
                              className="form-control"
                              dateFormat="yyyy/MM/dd"
                              selected={value}
                              onChange={date => {
                                setFieldValue('purchaseDate', date);
                                if (Number(values.startDateType_admin) === 1) {
                                  setFieldValue(
                                    'warrantyEndDate',
                                    moment(date)
                                      .add(
                                        info?.isInExtendDays
                                          ? info?.warrantyDays +
                                              info?.extendDays
                                          : info?.warrantyDays,
                                        'day',
                                      )
                                      .toDate(),
                                  );
                                }
                              }}
                            />
                          );
                        }}
                      </Field>
                    </div>
                    <div className="d-flex mb-3">
                      <Field
                        name="startDateType_admin"
                        type="radio"
                        id="shipping"
                        value="2"
                      >
                        {({ form, field }) => {
                          const { setFieldValue, values } = form;
                          const { value } = field;
                          return (
                            <input
                              className="me-2"
                              type="radio"
                              style={{ lineHeight: '38px' }}
                              checked={values.startDateType_admin == 2}
                              onChange={() => {
                                setFieldValue('startDateType_admin', value);
                                setFieldValue(
                                  'warrantyEndDate',
                                  values.shippingDate
                                    ? moment(values.shippingDate)
                                        .add(
                                          info?.isInExtendDays
                                            ? info?.warrantyDays +
                                                info?.extendDays
                                            : info?.warrantyDays,
                                          'day',
                                        )
                                        .toDate()
                                    : '',
                                );
                              }}
                            />
                          );
                        }}
                      </Field>
                      <label
                        className="w100"
                        htmlFor="shipping"
                        style={{ lineHeight: '38px' }}
                      >
                        出貨日期
                      </label>
                      <Field name="shippingDate">
                        {({ field, form }) => {
                          const { setFieldValue, values } = form;
                          const { value } = field;
                          return (
                            <DatePicker
                              className="form-control"
                              dateFormat="yyyy/MM/dd"
                              selected={value}
                              onChange={date => {
                                setFieldValue('shippingDate', date);
                                if (Number(values.startDateType_admin) === 2) {
                                  setFieldValue(
                                    'warrantyEndDate',
                                    moment(date)
                                      .add(
                                        info?.isInExtendDays
                                          ? info?.warrantyDays +
                                              info?.extendDays
                                          : info?.warrantyDays,
                                        'day',
                                      )
                                      .toDate(),
                                  );
                                }
                              }}
                            />
                          );
                        }}
                      </Field>
                    </div>
                  </div>
                </div>
              ) : null}
              {info?.warrantyDays ? (
                <div className={style.formGroup}>
                  <label style={{ width: '130px' }}>
                    保固結束日
                    <ErrorMessage
                      name="warrantyEndDate"
                      component="span"
                      className="form-error"
                    />
                  </label>
                  <div>
                    <div className="d-flex mb-3">
                      <Field name="warrantyEndDate">
                        {({ field, form }) => {
                          const { setFieldValue, values } = form;
                          const { value } = field;
                          return (
                            <DatePicker
                              className="form-control"
                              dateFormat="yyyy/MM/dd"
                              selected={values.warrantyEndDate}
                              onChange={date => {
                                setFieldValue('warrantyEndDate', date);
                              }}
                            />
                          );
                        }}
                      </Field>
                    </div>
                  </div>
                </div>
              ) : null}
              <div className={style.formGroup}>
                <label style={{ width: '130px' }}>
                  審核狀態
                  <ErrorMessage
                    name="status"
                    component="span"
                    className="form-error"
                  />
                  <ErrorMessage
                    name="reason"
                    component="h6"
                    className="form-error"
                  />
                </label>
                <div>
                  <div className="d-flex">
                    <div className="d-flex mb-3">
                      <Field
                        name="status"
                        type="radio"
                        style={{ lineHeight: '38px' }}
                        className="me-2"
                        id="notyet"
                        value={info?.status === '審核中' ? '審核中' : '未審核'}
                      />
                      <label
                        className="w100"
                        htmlFor="notyet"
                        style={{ lineHeight: '38px' }}
                      >
                        {info?.status === '審核中' ? '審核中' : '未審核'}
                      </label>
                    </div>

                    <div className="d-flex mb-3">
                      <Field
                        name="status"
                        type="radio"
                        style={{ lineHeight: '38px' }}
                        className="me-2"
                        id="fail"
                        value="未通過"
                      />
                      <label
                        className="w100"
                        htmlFor="fail"
                        style={{ lineHeight: '38px' }}
                      >
                        未通過
                      </label>
                    </div>

                    <div className="d-flex mb-3">
                      <Field
                        name="status"
                        type="radio"
                        style={{ lineHeight: '38px' }}
                        className="me-2"
                        id="success"
                        value="已通過"
                      />
                      <label
                        className="w100"
                        htmlFor="success"
                        style={{ lineHeight: '38px' }}
                      >
                        已通過
                      </label>
                    </div>
                    <div className="d-flex mb-3">
                      <Field
                        name="status"
                        type="radio"
                        style={{ lineHeight: '38px' }}
                        className="me-2"
                        id="cancel"
                        value="已作廢"
                      />
                      <label
                        className="w100"
                        htmlFor="cancel"
                        style={{ lineHeight: '38px' }}
                      >
                        已作廢
                      </label>
                    </div>
                  </div>
                  {(info && info.status == '未通過' && props.values.status == '未通過') || props.values.status == '未通過' ? (
                    <div className="mt-3">
                      {/* If old data selected one of the old options, show only that old option (on top) */}
                      {matchedOldOption ? (
                        <div className='d-flex mb-3' key='old_opt_selected'>
                          <input
                            name='reasonOption'
                            className='me-2'
                            type="radio"
                            style={{ lineHeight: '38px' }}
                            id='old_opt_selected'
                            checked={props.values.reasonOption === matchedOldOption}
                            onChange={() => {
                              props.setFieldValue('reasonOption', matchedOldOption);
                              props.setFieldValue('reason', matchedOldOption);
                              props.setFieldValue('otherText', '');
                              setOtherReason && setOtherReason('');
                            }}
                          />
                          <label className='w-100' htmlFor='old_opt_selected' style={{ lineHeight: '38px' }}>
                            {matchedOldOption}
                          </label>
                        </div>
                      ) : null}

                      {/* New 5 options - placed below old option */}
                      {newOptions.map((opt, idx) => (
                        <div className="d-flex mb-3" key={`new_opt_${idx}`}>
                          <input
                            name="reasonOption"
                            className="me-2"
                            type="radio"
                            style={{ lineHeight: '38px' }}
                            id={`new_opt_${idx}`}
                            checked={props.values.reasonOption === opt}
                            onChange={() => {
                              props.setFieldValue('reasonOption', opt);
                              props.setFieldValue('reason', opt);
                              props.setFieldValue('otherText', '');
                              setOtherReason && setOtherReason('');
                            }}
                          />
                          <label className="w-100" htmlFor={`new_opt_${idx}`} style={{ lineHeight: '38px' }}>
                            {opt}
                          </label>
                        </div>
                      ))}

                      {/* textarea for other reason (below new options) - bind to Formik */}
                      <div className="d-flex mb-3">
                        <input
                          name="reasonOption"
                          className="me-2"
                          type="radio"
                          style={{ lineHeight: '38px' }}
                          id='other_reason'
                          checked={props.values.reasonOption === 'OTHER' || (!anyMatch() && !!props.values.otherText)}
                          onChange={() => {
                            props.setFieldValue('reasonOption', 'OTHER');
                            props.setFieldValue('reason', props.values.otherText || '');
                            setOtherReason && setOtherReason(props.values.otherText || '');
                          }}
                        />
                        <textarea
                          placeholder="請輸入原因"
                          rows="5"
                          className="w-100 p-2"
                          value={props.values.otherText || ''}
                          onChange={e => {
                            props.setFieldValue('otherText', e.target.value);
                            props.setFieldValue('reason', e.target.value);
                            props.setFieldValue('reasonOption', 'OTHER');
                            setOtherReason && setOtherReason(e.target.value);
                          }}
                        ></textarea>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <div className={`mt-3 ${style.formGroup}`}>
                <label style={{ width: '130px' }}>審核狀態</label>
                <div>{info && info.status}</div>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button
                color="link"
                className={style.modal_button_cancel}
                onClick={toggleModal}
              >
                取消
              </Button>
              <Button
                type="submit"
                color="primary"
                className={style.modal_button_submit}
                disabled={addLoading || submitLoading}
              >
                {addLoading && (
                  <span
                    className="me-2 btn-wrapper--icon spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                )}
                {submitLoading && (
                  <span
                    className="me-2 btn-wrapper--icon spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                )}
                儲存
              </Button>
            </ModalFooter>
          </Form>
        );
      }}
      </Formik>
    </Modal>
  );
};

export default memo(WarrantyDateSettingModal);
